/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Native_Title6Inputs */

const en_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native when it counts`)
};

const ar_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أصلي عند الحاجة`)
};

const bn_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রয়োজনে নেটিভ`)
};

const de_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheimisch, wenn es darauf ankommt`)
};

const es_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nativo cuando cuenta`)
};

const fr_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natif quand ça compte`)
};

const pt_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nativo quando é importante`)
};

const zh_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重要时原生`)
};

const tr_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önemli olduğunda yerel`)
};

const ru_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нативный, когда это важно`)
};

const pl_svc_mobile_app_development_native_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natywny, jeśli ma to znaczenie`)
};

/**
* | output |
* | --- |
* | "Native when it counts" |
*
* @param {Svc_Mobile_App_Development_Native_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_native_title6 = /** @type {((inputs?: Svc_Mobile_App_Development_Native_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Native_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_native_title6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_native_title6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_native_title6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_native_title6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_native_title6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_native_title6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_native_title6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_native_title6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_native_title6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_native_title6(inputs)
	return en_svc_mobile_app_development_native_title6(inputs)
});
export { svc_mobile_app_development_native_title6 as "svc_mobile-app-development_NATIVE_title" }